import React, { forwardRef } from 'react';
import { cn } from '@/utils/cn';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  containerClassName?: string;
  className?: string;
  error?: string;
}

const Input = forwardRef<HTMLInputElement, InputProps>(({ containerClassName, className, error, ...props }, ref) => {
  return (
    <div className={cn('relative w-full flex flex-col gap-[1.5px]', containerClassName)}>
      <input
        ref={ref}
        {...props}
        className={cn(
          // Layout & size
          'h-[38px] w-full px-[12px] text-[14px] rounded-[8px]',
          // Base colors
          'border border-[#D9D9D9] text-[#4B4B4B] bg-[#ffffff]',
          // Focus & transition
          'outline-none transition-all duration-150',
          'focus:border-[#0C8DBF]',
          // Error state
          error && 'border-[#CC0202] focus:border-[#CC0202] focus-visible:ring-[#CC0202]/30',
          // Custom overrides
          className
        )}
      />
      {error && <span className="text-[10px] font-[400] text-[#CC0202]">{error}</span>}
    </div>
  );
});

Input.displayName = 'Input';
export default Input;
